import { createIcon } from '@chakra-ui/react'

export const RewardsIcon = createIcon({
  displayName: 'RewardsIcon',
  path: (
    <g fill='currentColor' fillRule='nonzero'>
      <path
        d='M2.0376 26C2.0376 27.1063 2.93135 28 4.0376 28H14.0376V18H2.0376V26ZM18.0376 28H28.0376C29.1438 28 30.0376 27.1063 30.0376 26V18H18.0376V28ZM30.0376 8H27.4063C27.7938 7.24375 28.0376 6.40625 28.0376 5.5C28.0376 2.46875 25.5688 0 22.5376 0C19.9376 0 18.2563 1.33125 16.1001 4.26875C13.9438 1.33125 12.2626 0 9.6626 0C6.63135 0 4.1626 2.46875 4.1626 5.5C4.1626 6.40625 4.4001 7.24375 4.79385 8H2.0376C0.931348 8 0.0375977 8.89375 0.0375977 10V15C0.0375977 15.55 0.487598 16 1.0376 16H31.0376C31.5876 16 32.0376 15.55 32.0376 15V10C32.0376 8.89375 31.1438 8 30.0376 8ZM9.65635 8C8.2751 8 7.15635 6.88125 7.15635 5.5C7.15635 4.11875 8.2751 3 9.65635 3C10.9001 3 11.8188 3.20625 15.0376 8H9.65635ZM22.5376 8H17.1563C20.3688 3.21875 21.2626 3 22.5376 3C23.9188 3 25.0376 4.11875 25.0376 5.5C25.0376 6.88125 23.9188 8 22.5376 8Z'
        fill='currentColor'
      />
    </g>
  ),
  viewBox: '0 0 32 28',
})
